import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, } from "react-router-dom";
import 'rsuite/dist/rsuite.min.css';

//i18n 
import './i18n';  // Import i18n configuration


import { useCookies } from 'react-cookie';
import DashboardLayout from './layout/authlayout';
import Dashboard from './componenets/dashboard';
import AboutUs from './componenets/About/About';
import { useLocation } from 'react-router-dom';



import AuthPage from './componenets/Auth/AuthPage';
// Blog
import IndexBlog from './componenets/Blog/indexBlog';
import ListBlog from './componenets/Blog/ListBlog';
import ListArticles from './componenets/Blog/ListArticles';
import EditBlog from './componenets/Blog/editBlog';

// Setting
import IndexSetting from './componenets/Setting/indexSetting';
import SettingPage from './componenets/Setting/general';
import SocialPage from './componenets/Setting/social';
import ContactPage from './componenets/Setting/contact';

//Gallery
import IndexGallery from './componenets/Gallery/indexGallery';
import GalleryList from './componenets/Gallery/listGallery';
import EditGallery from './componenets/Gallery/editGallery';
import EditDetail from './componenets/Gallery/DetailImage';
import ListSlider from './componenets/Gallery/listSlider';
import EditSlider from './componenets/Gallery/editSlider';

// User
import IndexUser from './componenets/User/indexUser';
import UserList from './componenets/User/UserList';
import EdtiUser from './componenets/User/EdtiUser';
// Menus 
import MenuGroup from './componenets/Menus/MenuGroup';
import MenuDetail from './componenets/Menus/MenuDetail';
// Logout
import { LogOut } from './logout/LogOut';
import "preline/preline";
import { IStaticMethods } from "preline/preline";
import EditPost from './componenets/Blog/editPost';
import FoodMenu from './pages';
import FeatureIndex from './componenets/Feature/featureIndex';
import IndexProducts from './componenets/Prodcuts/indexProducts';
import ListProductsGroup from './componenets/Prodcuts/listProductsGroup';
import EditProductsGroup from './componenets/Prodcuts/EditProductsGroup';
import ListofProducts from './componenets/Prodcuts/EditProductsGroup';
import ListPr from './componenets/Prodcuts/LisstProducts';
import EditProducts from './componenets/Prodcuts/EditProducts';
import ListBrands from './componenets/Prodcuts/ListBrands';
import EditBrand from './componenets/Prodcuts/EditBrand';
// Price Group
import ListPricesGroup from './componenets/Prodcuts/PriceGroup';
import ProductGroupEdit from './componenets/Prodcuts/PriceGroupEdit'
// Forms
import IndexForms from './componenets/Forms/indexForms'
import ListForm from './componenets/Forms/formGroup';
import EditForm from './componenets/Forms/EditFrom';

// Shop
import IndexShop from './componenets/Shop/indexShop';
import PostShop from './componenets/Shop/postShop';
import StoryDetail from './componenets/Story/Story';
import EditStory from './componenets/Story/EditStory';
import InvoiceList from './componenets/Invoice/InvoiceList';
import InvoiceDetial from './componenets/Invoice/InvoiceDetail';
import InvoiceLabel from './componenets/Invoice/InvoiceLabel';
import InvoiceLabelSimple from './componenets/Invoice/InvoiceLabelSimple';
import LabelProdcut from './componenets/Prodcuts/LabelProduct';
import CooperationList from './componenets/Cooperation/CooperationList';
import CooperationDetail from './componenets/Cooperation/CooperationDetail';
import ConsultationList from './componenets/Consultation/ConsultationList';
import ConsultationDetail from './componenets/Consultation/ConsultationDetail';

declare global {
  interface Window {
    HSStaticMethods: IStaticMethods;
  }
}

function App() {
  const [cookies] = useCookies(['token']);
  const token = cookies.token; // Retrieve the token
  //const location = useLocation();

  useEffect(() => {
    window.HSStaticMethods.autoInit();
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/logout" element={<LogOut />} />

        <Route path="/">
          <Route index element={!token ? <AuthPage /> : <Navigate to="/dashboard" />} />
        </Route>
        <Route
          path="/dashboard"
          element={token ? <DashboardLayout /> : <Navigate to="/" />}>
          <Route index element={<Dashboard />} />
          <Route path='about' element={<AboutUs />} />
          <Route path="Blog"  >
            <Route index element={<IndexBlog />} />
            <Route path="list" element={<ListBlog />} />
            <Route path="GroupEdit/:Id" element={<EditBlog />} />
            <Route path="Articles" element={<ListArticles />} />
            <Route path="EditPost/:Id" element={<EditPost />} />
          </Route>
          <Route path="Setting"  >
            <Route index element={<IndexSetting />} />
            <Route path="general" element={<SettingPage />} />
            <Route path="socialnetwork" element={<SocialPage />} />
            <Route path="contact" element={<ContactPage />} />
          </Route>
          <Route path="Gallery"  >
            <Route index element={<IndexGallery />} />
            <Route path="gallery" element={<GalleryList />} />
            <Route path="gallery/:Id" element={<EditGallery />} />
            <Route path="detailimage/:Id" element={<EditDetail />} />
            <Route path="list" element={<ListSlider />} />
            <Route path="list/:Id" element={<EditSlider />} />
          </Route>
          <Route path="User"  >
            <Route index element={<IndexUser />} />
            <Route path="list" element={<UserList />} />
            <Route path="list/:Id" element={<EdtiUser />} />
            <Route path="invoices" element={<InvoiceList />} />
            <Route path="invoices/:Id" element={<InvoiceDetial />} />
            <Route path="invoicesprice/:Id" element={<InvoiceLabel />} />
            <Route path="invoiceslabel/:Id" element={<InvoiceLabelSimple />} />

          </Route>
          <Route path="Feature"  >
            <Route index element={<FeatureIndex />} />
            <Route path="Menus" element={<MenuGroup />} />
            <Route path="Menus/:Id" element={<MenuDetail />} />
            <Route path="Story" element={<StoryDetail />} />
            <Route path="Story/:Id" element={<EditStory />} />

          </Route>
          <Route path="shop"  >
            <Route index element={<IndexShop />} />
            <Route path="post" element={<PostShop />} />

          </Route>
          <Route path="Products"  >
            <Route index element={<IndexProducts />} />
            <Route path="ProductsGroup" element={<ListProductsGroup />} />
            <Route path="ProductsGroup/:Id" element={<EditProductsGroup />} />
            <Route path="Products" element={<ListPr />} />
            <Route path="Products/:Id" element={<EditProducts />} />
            <Route path="Label/:Id" element={<LabelProdcut />} />

            <Route path="Brands" element={<ListBrands />} />
            <Route path="Brands/:Id" element={<EditBrand />} />


          </Route>
          <Route path="PriceGroup"  >
            <Route index element={<ListPricesGroup />} />
            <Route path=":Id" element={<ProductGroupEdit />} />

          </Route>
          <Route path="Forms"  >
            <Route index element={<IndexForms />} />
            <Route path="formlist" element={<ListForm />} />
            <Route path="formlist/:Id" element={<EditForm />} />

          </Route>
          <Route path="Cooperation"  >
            <Route path="list" element={<CooperationList />} />
            <Route path="list/:Id" element={<CooperationDetail />} />
          </Route>
          <Route path="Consultation"  >
            <Route path="list" element={<ConsultationList />} />
            <Route path="list/:Id" element={<ConsultationDetail />} />
          </Route>
        </Route>

      </Routes>


    </BrowserRouter>

  );
}

export default App;
